import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';
import { registerServiceWorker } from './lib/push';
import { AppearanceProvider } from './state/appearance';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <AppearanceProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AppearanceProvider>
    </ErrorBoundary>
  </StrictMode>,
);

// Registered after first paint: on an older Android phone the SW install
// competes with the initial render, and the app shell should win.
window.addEventListener('load', () => {
  void registerServiceWorker();
});
